import React, { useState, useEffect } from "react";
import "../../Clock.css";

function MainHeaderClock() {
  const [time, updateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      updateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // 24 saatlık format
  };

  return (
    <div className="elementcontainer">
      <div className="timeparent">
        <div className="timecontainerclock">
          <span className="timeclock">
            {time.toLocaleTimeString([], options)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default MainHeaderClock;
